// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactIf from "react-if";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Unicons$Showside from "../icons/Unicons.bs.js";
import * as IconCart$Showside from "../icons/IconCart.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as NavbarItem$Showside from "./NavbarItem.bs.js";
import * as UseSidebar$Showside from "../hook/UseSidebar.bs.js";
import * as IconSidebar$Showside from "../icons/IconSidebar.bs.js";
import * as StringUtils$Showside from "../utils/StringUtils.bs.js";
import * as BaseWithTheme$Showside from "../context/BaseWithTheme.bs.js";
import * as CartAnimation$Showside from "./CartAnimation.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import ReactVisibilitySensor from "react-visibility-sensor";
import * as BackToTopButton$Showside from "./BackToTopButton.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as UseCheckoutAction$Showside from "../hook/UseCheckoutAction.bs.js";
import * as CartContextProvider$Showside from "../context/CartContextProvider.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as FiltersFloatingButton$Showside from "./FiltersFloatingButton.bs.js";
import * as UseCategoryDisplayPriority$Showside from "../hook/UseCategoryDisplayPriority.bs.js";
function MobileNavbar(Props) {
  var position = Props.position;
  var showOpt = Props.show;
  var showSidebarOpt = Props.showSidebar;
  var showFiltersOpt = Props.showFilters;
  var showBackToTopButtonOpt = Props.showBackToTopButton;
  var shadowOpt = Props.shadow;
  var initiator = Props.initiator;
  var itemsAlign = Props.itemsAlign;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var onClick = Props.onClick;
  var show = showOpt !== undefined ? showOpt : true;
  var showSidebar = showSidebarOpt !== undefined ? showSidebarOpt : true;
  var showFilters = showFiltersOpt !== undefined ? showFiltersOpt : false;
  var showBackToTopButton = showBackToTopButtonOpt !== undefined ? showBackToTopButtonOpt : false;
  var shadow = shadowOpt !== undefined ? shadowOpt : false;
  var match = React.useState(function () {
    return show;
  });
  var setShow = match[1];
  var show$1 = match[0];
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = match$1.config;
  var settings = match$2.settings;
  var activeCategory = RouterProvider$Showside.useActiveCategory(undefined, undefined, match$2.categories);
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var route = match$3.route;
  var match$4 = CartContextProvider$Showside.useCart(undefined);
  var cart = match$4.cart;
  var isForcingPLP = UseCategoryDisplayPriority$Showside.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */1;
  var match$5 = ViewportContext$Showside.use(undefined);
  var breakpoint = match$5.breakpoint;
  var match$6 = EntrypointContext$Showside.use(undefined);
  var onBackClick = match$6.onBackClick;
  var onCloseNavigation = match$6.onCloseNavigation;
  var onHomeClick = match$6.onHomeClick;
  var toggleFiltersPanel = match$6.toggleFiltersPanel;
  var toggleSidebar = match$6.toggleSidebar;
  var lastProductAddedToCart = match$6.lastProductAddedToCart;
  var embedType = match$6.embedType;
  var favorites = Favorites$Showside.useFavorites(undefined);
  var match$7 = Favorites$Showside.useRecentlyAdded(undefined);
  var lastProductFavorited = match$7[0];
  var isHome;
  if (typeof route === "number" || route.TAG !== /* Home */0) {
    isHome = false;
  } else {
    var match$8 = route._0;
    isHome = Belt_Option.isNone(match$8.filters) && match$8.homeType === /* Index */0;
  }
  var match$9 = React.useState(function () {
    return false;
  });
  var setIsVisible = match$9[1];
  var match$10;
  if (typeof route === "number") {
    match$10 = [undefined, undefined, undefined, undefined, undefined];
  } else {
    switch (route.TAG | 0) {
      case /* Home */0:
      case /* ListPage */1:
        match$10 = ["navbar-button-back", "navbar-button-home", "navbar-button-sidebar", "navbar-button-checkout", "navbar-button-open-close"];
        break;
      case /* PDP */2:
        match$10 = ["pdp2-button-back", "pdp2-button-home", "pdp2-button-sidebar", "pdp2-button-checkout", "pdp2-button-open-close"];
        break;
      case /* QuickView */3:
        match$10 = [undefined, undefined, undefined, undefined, undefined];
        break;
    }
  }
  var openCloseTestId = match$10[4];
  var checkoutTestId = match$10[3];
  var sidebarTestId = match$10[2];
  var homeTestId = match$10[1];
  var backTestId = match$10[0];
  var zIndex = String(CSS$Showside.safeIncrementZIndex(settings.zIndexInt));
  var cartIconPixelAdjustments = breakpoint >= 2 ? "0 0 0 0" : "0 -3px 0 0";
  var iconSizeDiff = match$5.isMobile ? 2 : 0;
  var canRenderFavorites = favorites.source !== /* SourceLocalStorage */0 && embedType === /* Inline */1 ? false : favorites.enabled;
  var canRenderBackButton = settings.backButton;
  var canRenderSidebar = settings.linksAsSidebar && showSidebar;
  var canRenderCheckout = Belt_Option.isSome(settings.checkoutLink) || Belt_Option.isSome(match$4.setShowCartDrawer);
  var canRenderOpenClose = embedType !== /* Inline */1;
  var match$11 = UseSidebar$Showside.isEnabled(activeCategory, settings, match$3.listPageType, isForcingPLP);
  var canRenderFilters = match$11[1] && showFilters;
  var canRenderBackToTopButton = BackToTopButton$Showside.isEnabled(activeCategory, settings, isForcingPLP, match$3.productFilters) && showBackToTopButton;
  React.useEffect(function () {
    Curry._1(setShow, function (previous) {
      if (Belt_Option.isSome(lastProductAddedToCart) && canRenderCheckout || Belt_Option.isSome(lastProductFavorited) && canRenderFavorites) {
        return true;
      } else {
        return previous;
      }
    });
  }, [lastProductAddedToCart, lastProductFavorited]);
  React.useEffect(function () {
    Curry._1(setShow, function (previous) {
      if (Belt_Option.isSome(lastProductAddedToCart) && canRenderCheckout) {
        return previous;
      } else {
        return show;
      }
    });
  }, [show, lastProductAddedToCart]);
  var render = function (param) {
    var style = shadow ? {
      boxShadow: "0 -1px 3px 0 rgba(0, 0, 0, 0.1), 0 -1px 2px 0 rgba(0, 0, 0, 0.06)"
    } : {};
    var style$1 = Object.assign({}, style, {
      zIndex: zIndex
    });
    var positionCn;
    switch (position) {
      case /* Sticky */0:
        positionCn = "sticky";
        break;
      case /* Fixed */1:
        positionCn = "fixed";
        break;
      case /* Relative */2:
        positionCn = "relative";
        break;
    }
    var itemsAlignCn = itemsAlign !== undefined ? itemsAlign : position >= 2 ? "items-stretch" : "items-center";
    var buttonsCount = Belt_Array.reduce([canRenderBackButton, canRenderCheckout, canRenderSidebar, canRenderOpenClose], 0, function (acc, curr) {
      return acc + (curr ? 1 : 0) | 0;
    });
    var justifyCn = buttonsCount === 1 ? "justify-center" : "justify-between";
    var match = UseCheckoutAction$Showside.useCheckoutAction(undefined);
    var checkoutOnClick = match.onClick;
    var checkoutHref = match.href;
    var canRenderBar = canRenderBackButton || canRenderCheckout || canRenderSidebar || canRenderOpenClose || canRenderFavorites;
    var tmp = {
      className: CSS$Showside.prefix(Cn.make(["smartnav-mobile-navbar", positionCn, itemsAlignCn, "left-0 shadow-sm", show$1 || !canRenderBar ? "bottom-0" : "-bottom-16", "bg-main text-primary", breakpoint >= /* Md */2 || !canRenderBar ? "h-0" : "h-16", "w-full flex px-5", justifyCn, "transition-all duration-300"])),
      style: style$1
    };
    if (onClick !== undefined) {
      tmp.onClick = Caml_option.valFromOption(onClick);
    }
    var tmp$1 = {};
    if (scrollableContainerRef !== undefined) {
      tmp$1.scrollableContainerRef = Caml_option.valFromOption(scrollableContainerRef);
    }
    var tmp$2 = {
      label: "Back",
      children: React.createElement(Unicons$Showside.UilAngleLeftB.make, {
        size: /* Px */{
          _0: 26 + iconSizeDiff | 0
        }
      }),
      onClick: function (param) {
        if (embedType === /* Inline */1 && isHome) {
          return;
        } else {
          return Curry._1(onBackClick, undefined);
        }
      },
      className: CSS$Showside.prefix(embedType === /* Inline */1 && isHome ? "opacity-25" : ""),
      disabled: false,
      position: /* Fixed */1
    };
    if (backTestId !== undefined) {
      tmp$2.dataTestId = Caml_option.valFromOption(backTestId);
    }
    var tmp$3 = {
      label: "Home",
      children: React.createElement(Unicons$Showside.UilEstate.make, {
        size: /* Px */{
          _0: 21
        },
        className: CSS$Showside.prefix("w-full")
      }),
      show: true,
      onClick: function (param) {
        if (isHome) {
          return;
        } else {
          return Curry._1(onHomeClick, undefined);
        }
      },
      className: CSS$Showside.prefix(isHome ? "opacity-25" : ""),
      position: /* Fixed */1
    };
    if (homeTestId !== undefined) {
      tmp$3.dataTestId = Caml_option.valFromOption(homeTestId);
    }
    var tmp$4 = {
      label: "Sidebar",
      children: React.createElement(IconSidebar$Showside.make, {}),
      onClick: function (param) {
        Curry._1(toggleSidebar, undefined);
      },
      position: position
    };
    if (sidebarTestId !== undefined) {
      tmp$4.dataTestId = Caml_option.valFromOption(sidebarTestId);
    }
    var tmp$5;
    var exit = 0;
    if (checkoutHref !== undefined || checkoutOnClick !== undefined) {
      exit = 1;
    } else {
      tmp$5 = null;
    }
    if (exit === 1) {
      var tmp$6 = {
        label: "Checkout",
        children: React.createElement(IconCart$Showside.make, {
          size: 22 + iconSizeDiff | 0
        }),
        show: Belt_Option.isSome(settings.checkoutLink),
        openLinkInNewTab: settings.openLinkInNewTab,
        pixelAdjustments: cartIconPixelAdjustments,
        position: /* Fixed */1
      };
      if (checkoutOnClick !== undefined) {
        tmp$6.onClick = Caml_option.valFromOption(checkoutOnClick);
      }
      if (checkoutHref !== undefined) {
        tmp$6.href = checkoutHref;
      }
      var tmp$7 = StringUtils$Showside.fromInt(99, undefined, cart.itemCount);
      if (tmp$7 !== undefined) {
        tmp$6.badge = Caml_option.valFromOption(tmp$7);
      }
      if (checkoutTestId !== undefined) {
        tmp$6.dataTestId = Caml_option.valFromOption(checkoutTestId);
      }
      tmp$5 = React.createElement("div", {
        className: CSS$Showside.prefix("relative pointer-events-auto")
      }, React.createElement(NavbarItem$Showside.make, tmp$6), React.createElement(CartAnimation$Showside.make, {
        productDirection: /* Top */0,
        tooltipDirection: /* Left */2,
        addedLabel: settings.pdpAddToCartConfirmation,
        className: CSS$Showside.prefix("absolute w-full h-full")
      }));
    }
    var tmp$8 = {
      label: "Open",
      children: React.createElement("div", {
        className: CSS$Showside.prefix("transform -rotate-90")
      }, React.createElement(ReactIf.If, {
        condition: settings.smartbarEnabled,
        children: null
      }, React.createElement(ReactIf.Then, {
        children: React.createElement(Unicons$Showside.UilAngleLeftB.make, {
          size: /* Px */{
            _0: 28 + iconSizeDiff | 0
          }
        })
      }), React.createElement(ReactIf.Else, {
        children: React.createElement(Unicons$Showside.UilTimes.make, {
          size: /* Px */{
            _0: 28 + iconSizeDiff | 0
          }
        })
      }))),
      onClick: function (param) {
        Curry._1(onCloseNavigation, undefined);
      },
      position: position
    };
    if (openCloseTestId !== undefined) {
      tmp$8.dataTestId = Caml_option.valFromOption(openCloseTestId);
    }
    return React.createElement(React.Fragment, undefined, React.createElement(ConditionalRender$Showside.When.make, {
      condition: canRenderBar || canRenderFilters || canRenderBackToTopButton,
      children: React.createElement("div", tmp, React.createElement(ConditionalRender$Showside.When.make, {
        condition: canRenderFilters,
        children: React.createElement(FiltersFloatingButton$Showside.make, {
          onClick: function (param) {
            Curry._1(toggleFiltersPanel, undefined);
          }
        })
      }), React.createElement(ConditionalRender$Showside.When.make, {
        condition: canRenderBackToTopButton,
        children: React.createElement(BackToTopButton$Showside.make, tmp$1)
      }), React.createElement(ReactVisibilitySensor, {
        partialVisibility: true,
        onChange: function (visible) {
          Curry._1(setIsVisible, function (param) {
            return visible;
          });
        },
        children: React.createElement(React.Fragment, undefined, React.createElement(ConditionalRender$Showside.When.make, {
          condition: canRenderBackButton,
          children: React.createElement(NavbarItem$Showside.make, tmp$2)
        }), React.createElement(ConditionalRender$Showside.When.make, {
          condition: embedType !== /* Inline */1,
          children: React.createElement(NavbarItem$Showside.make, tmp$3)
        }), React.createElement(ConditionalRender$Showside.When.make, {
          condition: canRenderSidebar,
          children: React.createElement(NavbarItem$Showside.make, tmp$4)
        }), React.createElement(ConditionalRender$Showside.When.make, {
          condition: canRenderCheckout,
          children: tmp$5
        }), React.createElement(ConditionalRender$Showside.When.make, {
          condition: canRenderFavorites,
          children: React.createElement(Favorites$Showside.OpenButton.make, {})
        }), React.createElement(ConditionalRender$Showside.When.make, {
          condition: canRenderOpenClose,
          children: React.createElement(NavbarItem$Showside.make, tmp$8)
        }))
      }))
    }));
  };
  if (position !== 1) {
    return render(undefined);
  } else {
    return React.createElement(BaseWithTheme$Showside.make, {
      initiator: initiator,
      portal: true,
      children: render(undefined)
    });
  }
}
MobileNavbar.displayName = "MobileNavbar";
var make = React.memo(MobileNavbar);
export { make };
/* make Not a pure module */